export const VendingPaymentChannels = {
    Twint: "Twint",
    SMSSunrise: "SMSSunrise",
    SMSSwisscom: "SMSSwisscom",
    SMSSalt: "SMSSalt",
    PostFinanceCard: "PostFinanceCard",
    PostFinanceCard2:  "PostFinance",
    PostFinanceCard3: "PFC",
    CreditCard: "CreditCard",
    CreditCard2: "ECA,VIS",
    CreditCard3: "Credit card",
    ApplePay: "ApplePay",
    ApplePay2: "APL",
    GooglePay: "GooglePay",
    GooglePay2: "PAY",
    Cash: "cash",
    TechPsp: "TechPsp",
    Cashless1: "Cashless1",
    MoneyStack: "MoneyStack",
    WalletExternal: "WalletExternal",
    Reka: "Reka",
    Mobile: "Mobile",
    AmericanExpress: "AmericanExpress",
    AmericanExpress2: "AmericanExpress",
    Visa: "Visa",
    Visa2: "VIS",
    MasterCard: "MasterCard",
    MasterCard2: "ECA",
    Sms: "Sms",
    DigitalWallet: "APL,PAY",
    DigitalWallet2:  "ApplePay/GooglePay",
    V_PAY:  "V-PAY",
    V_PAY2: "VPY",
    MaestroCard: "MAE" ,
    MaestroCard2: "MaestroCard",
    Smarpay: "Smarpay",
    Freevend: "Freevend",
    None: "None",
}